// src/Components/LoadingComp/LoadingScreen.js
import React from 'react';
import './loadingscreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <h1>EYE CARE INSTITUTE, SRI LANKA</h1>
        <img 
          src="/round-eyecare.webp"  
          alt="eye care logo" 
          className="spinning-wheel"
           loading="lazy"
        />
      </div>
    </div>
  );
};

export default LoadingScreen;